import { NextPage } from 'next'
import { MetaTags } from '~shared'
import { Grid, Layout } from '~ui'
import Tickets from 'components/tickets'
import StarsNearYou from 'components/tickets/near-you-stars'
import CategoryEventsSlider from 'components/tickets/category-slider'

const ComedyTicketsPage: NextPage = () => (
  <Layout>
    <MetaTags title="Comedy tickets" />
    <Layout.Banner />
    <Layout.HomeHeader />
    <Layout.Main withPadding={false} withSidebar={false} backgroundColor="black">
      <Grid gap="80px" paddingBottom="80px">
        <Tickets
          backgroundImage="url(https://img.granted.co/1656084367403-comedy-tickets.png)"
          title="comedy tickets"
          color="teal"
          icon="live"
          description="Live, laugh, LOL. Choose your favorite comedian or search their name below."
        />

        <StarsNearYou title="Shows near" categoryId={process.env.NEXT_PUBLIC_COMEDY_CATEGORY} />

        <CategoryEventsSlider
          title="Performers"
          mainCategory={process.env.NEXT_PUBLIC_COMEDY_CATEGORY}
        />
      </Grid>
    </Layout.Main>
    <Layout.Footer />
  </Layout>
)
export default ComedyTicketsPage
